import { lazy, ComponentType } from "react";

const STORAGE_KEY = "lazy-retry-refreshed";

/**
 * Wraps React.lazy with a one-shot page refresh on chunk load failures.
 * This handles the "Failed to fetch dynamically imported module" error
 * that occurs when the server has removed old chunks after a new deploy.
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    const alreadyRefreshed = JSON.parse(
      window.sessionStorage.getItem(STORAGE_KEY) || "false"
    );

    try {
      const component = await factory();
      window.sessionStorage.setItem(STORAGE_KEY, "false");
      return component;
    } catch (error) {
      if (!alreadyRefreshed) {
        window.sessionStorage.setItem(STORAGE_KEY, "true");
        window.location.reload();
        // Return a never-resolving promise while reload happens
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    }
  });
}
